import type { Agency } from '~/types/api'

export function useDefaultAgencyState() {
    return useState<Agency | null | undefined>('default_agency', () => undefined)
}
